/**
 * Swiper core plus exactly the two modules this theme uses.
 *
 * The hand-downloaded swiper-bundle.min.js carried every module Swiper ships: virtual,
 * keyboard, mousewheel, scrollbar, parallax, zoom, controller, a11y, history, hashnav,
 * autoplay, thumbs, freemode, grid, manipulation, and the cube/flip/coverflow/creative/
 * cards effects. The theme instantiates Swiper four times, all of them below, and
 * configures two things: navigation arrows and pagination dots.
 *
 * Naming the modules here is what excludes the other twenty — there is no separate
 * slimming step, and no way for an unused module to creep back in without appearing on
 * this line. `Swiper.use()` at module scope registers them once for all four instances,
 * which is what the bundle entry did internally.
 *
 * Phase 2 imported `swiper/bundle` deliberately, to keep that phase behaviour-neutral
 * while the module set was still an open question. This is Phase 3 of
 * docs/js-build-review.md making the cut.
 */
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import Cookies from 'js-cookie';

Swiper.use([Navigation, Pagination]);

document.addEventListener('alpine:init', () => {
	// `newsletterForm` used to live here. It is used on exactly one page — the member
	// centre — which no longer loads this bundle at all, so it moved to
	// js/member-newsletter.js along with the fixes in docs/member-flow-review.md
	// M17-M19. Everything else in this file is untouched.

	Alpine.data('postMask', () => ({
		maxHeight: 'unset',
		later: false,
		hasClosedPostMask: undefined,
		open: false,
		init: function () {
			this.hasClosedPostMask = Cookies.get('tr.has_closed_post_mask');

			if (this.hasClosedPostMask == '1') {
				this.open = false;
				this.unsetMaxHeight();
				return;
			} else {
				this.open = true;
				this.setMaxHeight();
			}
		},
		setMaxHeight: function () {
			if (!this.later) {
				const paragraphs =
					this.$root.querySelectorAll('.entry-content p');
				if (paragraphs.length > 1) {
					const thirdParagraph = paragraphs[0];
					const thirdParagraphOffset =
						thirdParagraph.offsetTop + thirdParagraph.offsetHeight;
					this.maxHeight = thirdParagraphOffset + 'px';
				} else {
					// const maxHeight = this.$root.scrollHeight / 2;
					// this.maxHeight = maxHeight + 'px';
				}
			}
		},
		unsetMaxHeight: function () {
			this.later = true;
			this.maxHeight = 'unset';
		},
		close: function () {
			// 1 for 1 day
			Cookies.set('tr.has_closed_post_mask', '1', {
				path: '',
				expires: 1,
			});
			this.open = false;
			this.unsetMaxHeight();
		},
	}));

	Alpine.data('subCatLatest', () => ({
		loading: false,
		page: 2, // start from page 2
		posts: [],
		html: '',
		getLatestPosts: async function () {
			try {
				const maxNumPages = parseInt(this.$root.dataset.maxNumPages);

				if (this.page > maxNumPages) {
					alert('已沒有更多文章\nNo more articles');
					return;
				}

				const categoryId = this.$root.dataset.categoryId;
				const attributes = JSON.parse(this.$root.dataset.attributes);
				// /wp-json/wp/v1/posts?_embed&per_page=20&page=${this.page}&categories=${categoryId}&orderby=date&order=desc
				const response = await fetch(`/wp-json/tr/v1/sub-cat-3`, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({
						attributes,
						page: this.page,
						categories: categoryId,
					}),
				});
				this.loading = true;
				if (response.ok) {
					const data = await response.text();
					if (!data) {
						alert('已沒有更多文章\nNo more articles');
						return;
					}
					this.html += data;
					this.loading = false;
					this.page += 1;
				} else {
					const data = await response.json();
					if (data?.code === 'rest_post_invalid_page_number') {
						alert('已沒有更多文章\nNo more articles');
					}
				}
			} catch (e) {
				console.log(e);
				alert('系統繁忙，請稍後再試。');
				this.loading = false;
			}
		},
	}));

	Alpine.data('popUp', () => ({
		hasClosedPopUp: undefined,
		open: false,
		second: 10,
		delay: function (ms) {
			return new Promise((res) => setTimeout(res, ms));
		},
		init: function () {
			this.hasClosedPopUp = Cookies.get('tr.has_closed_pop_up');
			if (this.hasClosedPopUp == '1') {
				this.open = false;
			} else {
				this.open = true;
				this.countDown();
			}
		},
		close: function () {
			Cookies.set('tr.has_closed_pop_up', '1', {
				path: '',
				expires: 1,
			});
			this.open = false;
		},
		countDown: async function () {
			// use php check
			// if (this.$refs.adsEl.hasChildNodes()) {
			// setTimeout(() => {
			this.$nextTick(() => {
				this.hidden = false;
			});
			// }, 500);
			// console.log(1234, this.hidden);
			const timer = setInterval(() => {
				this.second = this.second - 1;
			}, 1000);
			await this.delay(10000);
			clearInterval(timer);

			this.$nextTick(() => {
				this.hidden = true;
			});
			// this.hidden = true;
			// }
		},
	}));

	Alpine.data('carousel', () => ({
		swiper: undefined,
		tab: 'hot',
		maxHeight: '0px',
		setMaxHeight: function () {
			const el = this.$refs.swiperEl;
			this.maxHeight = el.getBoundingClientRect().height + 'px';
			console.log(this.maxHeight);
		},
		initSwiper: function () {
			const el = this.$refs.swiperEl;

			this.swiper = new Swiper(el, {
				loop: true,
				autoplay: false,
				/*
				autoplay: {
					delay: 5000,
					disableOnInteraction: true,
					pauseOnMouseEnter: true,
				},
				*/
				pagination: {
					el: this.$refs.paginationEl,
				},
				pauseOnMouseEnter: true,
				navigation: {
					nextEl: this.$refs.nextEl,
					prevEl: this.$refs.prevEl,
				},
				autoHeight: false,
				preloadImages: false,
				lazy: { loadPrevNext: true },
				noSwipingClass: 'swiper-no-swiping',
			});
		},
	}));

	Alpine.data('carouselAutoHeight', () => ({
		swiper: undefined,
		maxHeight: '0px',
		setMaxHeight: function () {
			const el = this.$refs.swiperEl;
			this.maxHeight = el.getBoundingClientRect().height + 'px';
			console.log(this.maxHeight);
		},
		initSwiper: function () {
			const el = this.$refs.swiperEl;

			this.swiper = new Swiper(el, {
				loop: true,
				autoplay: true,
				/*
				autoplay: {
					delay: 5000,
					disableOnInteraction: true,
					pauseOnMouseEnter: true,
				},
				*/
				pagination: {
					el: this.$refs.paginationEl,
				},
				pauseOnMouseEnter: true,
				navigation: {
					nextEl: this.$refs.nextEl,
					prevEl: this.$refs.prevEl,
				},
				autoHeight: false,
				preloadImages: false,
				lazy: { loadPrevNext: true },
				noSwipingClass: 'swiper-no-swiping',
			});
		},
	}));

	Alpine.data('cards', () => ({
		titles: undefined,
		subtitles: undefined,
		excerpts: undefined,
		footers: undefined,
		standardizeHeight: function (selectors = []) {
			for (const selector of selectors) {
				const elements = this.$el.querySelectorAll(selector);
				// console.log(elements);
				if (elements?.length === 0) {
					return;
				}
				const maxHeight = Math.max(
					...Array.from(elements).map(
						(element) => element.offsetHeight
					)
				);

				for (const element of Array.from(elements)) {
					if (maxHeight === 0) {
						element.classList.add('contents');
					}
					element.style.height = `${maxHeight}px`;
				}
			}
		},
	}));

	const sliderBase = {
		swiper: undefined,
		loop: false,
		slidesPerView: 5,
		initSwiper: function () {
			const el = this.$refs.swiperEl;

			this.swiper = new Swiper(el, {
				loop: this.loop,
				spaceBetween: 8,
				slidesPerView: 2,
				breakpoints: {
					768: {
						slidesPerView: this.slidesPerView,
						spaceBetween: 16,
					},
				},
				autoplay: false,
				pauseOnMouseEnter: true,
				navigation: {
					prevEl: this.$refs.prevEl,
					nextEl: this.$refs.nextEl,
				},
				autoHeight: false,
				preloadImages: false,
				lazy: { loadPrevNext: true },
				noSwipingClass: 'swiper-no-swiping',
			});
		},
	};

	Alpine.data('postBottomSlider', () => ({
		...lodash.cloneDeep(sliderBase),
		slidesPerView: 4.2,
		navigator: null,
	}));

	Alpine.data('sliderMinimal', () => ({
		...lodash.cloneDeep(sliderBase),
	}));

	Alpine.data('slider', () => ({
		swiper: undefined,
		maxItems: undefined,
		itemsPerView: undefined,
		isScrollable: true,
		initVars: function () {
			try {
				const dataset = JSON.parse(this.$root.dataset.attributes);
				this.maxItems = dataset.max_items;
				this.itemsPerView = dataset.items_per_view;
				this.isScrollable = dataset.is_scrollable;
			} catch {
				throw 'no data-attributes';
			}
		},
		initSwiper: function () {
			const el = this.$refs.swiperEl;

			this.swiper = new Swiper(el, {
				loop: true,
				spaceBetween: 8,
				slidesPerView: 2,
				allowSlidePrev: this.isScrollable,
				allowSlideNext: this.isScrollable,
				breakpoints: {
					768: {
						slidesPerView: this.itemsPerView,
						spaceBetween: 16,
					},
				},
				autoplay: false,
				/*
				autoplay: {
					delay: 5000,
					disableOnInteraction: true,
					pauseOnMouseEnter: true,
				},
				*/
				pauseOnMouseEnter: true,
				pagination: {
					el: this.$refs.paginationEl,
				},
				navigation: this.isScrollable
					? {
							nextEl: this.$refs.nextEl,
							prevEl: this.$refs.prevEl,
						}
					: undefined,
				autoHeight: false,
				preloadImages: false,
				lazy: { loadPrevNext: true },
				noSwipingClass: 'swiper-no-swiping',
			});
		},
	}));
});
